/* export_devices.icon.svg.js */

module.exports = {
    icon: `
        <svg viewBox="0 0 20 20" preserveAspectRatio="none">
        <g>
            <path class="foreground-gl" d="M2.3,15.5V2.7h5.7v2.4c0,0.8,0.5,1.4,1.1,1.4h1.8v3.2h2.3V5.1c0-0.4-0.1-0.8-0.3-1l0,0l0,0l0,0L9.9,0.4c0,0,0,0-0.1-0.1
                l0,0l0,0C9.7,0.1,9.4,0,9.1,0H1.1C0.5,0,0,0.6,0,1.4v15.2v0.9v1.1C0,19.4,0.5,20,1.1,20H12c0.6,0,1.1-0.6,1.1-1.4v-1.4H2.3V15.5z"
                />
            <path class="foreground-gl" d="M19.6,13L15,10.6l0.6,1.6h-0.9h-2.3H9.5c-0.6,0-1.1,0.6-1.1,1.4c0,0.8,0.5,1.4,1.1,1.4h2.9h2.3h0.9L15,16.6l4.6-2.4
                C20.1,14.1,20.1,13.2,19.6,13z"/>
        </g>
        </svg>
`
};
